import React from 'react';
import trackerAccessLevels from '@lib/constants/trackerAccessLevels';
import { connectWithStore } from '@react/Common/connectWithStore';
import {
  getUserPermissionsState,
  changeTrackerPermissions,
  saveTrackerPermissions,
} from '@redux/ducks/userPermissions/userPermissions';
import { TrackerRole } from '@redux/ducks/userPermissions/utils';
import { UpdateKeywords } from './UpdateKeywords';

const TrackerAccessPageComponent = ({ onCancel, onApply, currentTracker, trackerRoles, changeTrackerPermissions }) => (
  <div className="content-panel flex-one flex-box-column">
    <div className="content-title-box without-background">
      <div className="flex-auto">
        <h3 className="content-heading">{t(currentTracker.label)}</h3>
      </div>
    </div>

    <div className="content-inner flex-one flex-box-column">
      <div className="content panel-content flex-one">
        <div className="form-row form-row-slim">
          <label>{t('label.access')}</label>

          <div className="role-tags">
            {trackerRoles.map(role => (
              <a
                key={role.key}
                onClick={() => changeTrackerPermissions(role.value)}
                className={`role-btn role-${role.key} ${currentTracker.access?.role === role.value ? 'active' : ''}`}
              >
                {t(role.name)}
              </a>
            ))}
          </div>

          <div className="role-desc">
            {trackerRoles.map(role =>
              (TrackerRole[currentTracker.access?.role] || TrackerRole.off) === role.key ? (
                <p key={role.key}>{t(role.description)}</p>
              ) : null,
            )}
          </div>
        </div>

        <UpdateKeywords />
      </div>
      <div className="content panel-content flex-auto">
        <div className="panel-footer flex-auto">
          <div className="flex-box-row">
            <a onClick={onCancel} className="btn flex-one">
              {t('action.back')}
            </a>
            <button onClick={onApply} className="btn btn-main flex-one">
              {t('action.apply')}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
);

const mapStateToProps = state => {
  const { currentTracker } = getUserPermissionsState(state);

  return { currentTracker, trackerRoles: trackerAccessLevels };
};

const mapStateToDispatch = {
  changeTrackerPermissions,
  onApply: saveTrackerPermissions,
};

export const TrackerAccessPage = connectWithStore(mapStateToProps, mapStateToDispatch)(TrackerAccessPageComponent);
